import React from "react";
import { contactBg } from "../../../assets/images";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <div className="bg-[#EDEDED] py-10 md:py-20">
      <div className="md:max-w-container max-w-containerSm w-full mx-auto">
        <div
          style={{
            backgroundImage: `url(${contactBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: window.innerWidth < 640 ? "266px" : "375px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Dikeyde ortalar
            alignItems: "center", // Yatayda ortalar
            textAlign: "center",
            borderRadius: "4px",
          }}
        >
          <p className="text-center text-[14px] font-medium text-[#B31F11]">
            {t("GET IN TOUCH")}
          </p>
          <p className="text-center text-white text-[20px] md:text-[44px] font-bold mt-3 max-w-containerSm md:w-[768px] font-firstFont">
            {t("Have questions or need a quote? We’re just a message away.")}
          </p>
          <div className="w-full">
            <a
              className="w-full md:w-auto"
              href={`/${currentLanguage}/contact`}
            >
              <button className="h-[44px] w-[90%] md:w-[125px] mt-[24px] md:mt-[32px] bg-[#B31F11] text-white rounded-[4px]">
                {t("Contact")}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
